import { cn } from '@/lib/cn';

interface SwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  /** Visually hide the label but keep it as the accessible name. */
  hideLabel?: boolean;
  disabled?: boolean;
  tone?: 'brand' | 'danger';
}

export function Switch({ checked, onChange, label, hideLabel, disabled, tone = 'brand' }: SwitchProps) {
  const on = tone === 'danger' ? 'bg-danger' : 'bg-brand';
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={hideLabel ? label : undefined}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={cn(
        'inline-flex items-center gap-2.5 text-sm text-fg-muted transition-opacity disabled:cursor-not-allowed disabled:opacity-50'
      )}
    >
      <span
        className={cn(
          'relative h-5 w-9 shrink-0 rounded-full transition-colors duration-150',
          checked ? on : 'bg-surface-3 ring-1 ring-line-strong ring-inset'
        )}
      >
        <span
          className={cn(
            'absolute top-0.5 left-0.5 h-4 w-4 rounded-full bg-white transition-transform duration-150',
            checked && 'translate-x-4'
          )}
        />
      </span>
      {!hideLabel && <span>{label}</span>}
    </button>
  );
}
